export enum UserAgreementType {
    ElectronicRecordsAndDisclosures = 0,
    AdminTermsAndConditions = 1,
}
